module.exports = __webpack_public_path__ + "9681cccf7de26910f72b4738713f71cc.jpg";